// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bounding-box';

export const Component = () => (
  <path d='M8.813 4.885v-.958h6.896v.958H8.813Zm0 15.709v-.958h6.896v.958H8.813Zm-4.886-4.885V8.813h.958v6.896h-.958Zm15.709 0V8.813h.958v6.896h-.958ZM.958.958h6.897v6.897H.958V.958Zm7.854 7.854V0H0v8.813h8.813ZM16.666.958h6.897v6.897h-6.897V.958Zm7.855 7.854V0H15.71v8.813h8.812Zm-7.855 7.855h6.897v6.897h-6.897v-6.897Zm7.855 7.854V15.71H15.71v8.812h8.812ZM.958 16.667h6.897v6.897H.958v-6.897Zm7.854 7.854V15.71H0v8.812h8.813Z' />
);

export const viewBox = '0 0 25 25';
